import { useEffect, useState } from 'react'
import api from './api'

// Nama usaha dari GET /api/public/branding (TANPA auth -- lihat server/routes/public.js) --
// dipakai halaman yg belum/tidak pernah login (Login.jsx) & halaman publik berbasis token
// (TiketForm.jsx, PekerjaanItemForm.jsx) selain halaman terautentikasi (Layout.jsx, SlipDoc.jsx),
// supaya "FazNet" tidak hardcode di 5 tempat berbeda (2026-07-22, audit portabilitas/white-label).
// Default 'FazNet' dipakai SEBELUM response API datang (hindari flash teks kosong), bukan berarti
// hardcode -- begitu API selesai, langsung diganti nilai sungguhan dari bot_config.
export default function useBranding() {
  const [businessName, setBusinessName] = useState('FazNet')
  useEffect(() => {
    api.get('/public/branding').then(r => setBusinessName(r.data.businessName)).catch(() => {})
  }, [])
  return businessName
}
